<template>
  <div>
    <div class="min-vh">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mb-0 header-main text-uppercase">IMAGE MAP</h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row>
          <b-col class="d-flex justify-content-end">
            <div class="language-filter my-auto ml-0 ml-sm-4">
              <b-button-group class="btn-language">
                <b-button
                  :class="{ active: languageActiveId == 1 }"
                  @click="onChangeLanguageActive(1)"
                  >TH</b-button
                >
                <b-button
                  :class="{ active: languageActiveId == 2 }"
                  @click="onChangeLanguageActive(2)"
                  >EN</b-button
                >
              </b-button-group>
            </div>
          </b-col>
        </b-row>

        <div v-for="(item, index) in form.imageMap" :key="index">
          <b-row
            v-bind:class="[
              languageActiveId == item.imageMap.languageId ? 'mt-3' : 'd-none',
            ]"
          >
            <b-col md="5">
              <div
                class="panel-bg-file-img mr-1 mb-1"
                v-bind:style="{
                  backgroundImage: 'url(' + item.imageMap.imageUrl + ')',
                }"
              >
                <img
                  src="/img/loading.svg"
                  class="loading"
                  alt="loading"
                  v-if="isLoadingImage"
                />
              </div>
            </b-col>
            <b-col md="7">
              <UploadFile
                textFloat="Cover Image"
                placeholder="กรุณาเลือกไฟล์เพื่ออัพโหลด"
                format="image"
                name="thumbnail"
                :fileName="item.imageMap.imageUrl"
                text="*Please upload only file .png, .jpg size 1:1  and less than 10 MB"
                isRequired
                :itemIndex="index"
                v-on:onFileChange="onImageChange"
                v-on:delete="onDeleteImage"
                :v="$v.form.imageMap.$each.$iter[index].imageMap.imageUrl"
              />
            </b-col>
          </b-row>
          <b-row
            class="mt-3"
            v-bind:class="[
              languageActiveId == item.imageMap.languageId ? 'mt-3' : 'd-none',
            ]"
          >
            <b-col>
              <InputTextArea
                class=""
                type="text"
                textFloat="Text"
                placeholder=""
                name="text"
                rows="5"
                isRequired
                v-model="item.imageMap.description"
                :isValidate="
                  $v.form.imageMap.$each.$iter[index].imageMap.description
                    .$error
                "
                :v="$v.form.imageMap.$each.$iter[index].imageMap.description"
              />
            </b-col>
          </b-row>
          <b-row
            v-bind:class="[ 'main-theme', 
              languageActiveId == item.imageMap.languageId ? 'mt-3' : 'd-none',
            ]"
          >
            <b-col>
              <div class="font-weight-bold">Opions</div>

              <div class="mt-1">
                <b-table
                  class="table-list-imagemap"
                  responsive
                  striped
                  hover
                  :items="item.action"
                  :fields="fields"
                  :busy="isBusy"
                  show-empty
                  empty-text="ไม่พบข้อมูล"
                >
                  <template v-slot:table-busy>
                    <div class="text-center text-black my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="ml-2">Loading...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(label)="data">
                    <InputText
                      v-if="data.item.isEdit"
                      textFloat=""
                      placeholder=""
                      type="text"
                      name="dataText"
                      isRequired
                      v-model="data.item.label"
                      :isValidate="
                        $v.form.imageMap.$each.$iter[index].action.$each.$iter[
                          data.index
                        ].label.$error
                      "
                    />
                    <span v-else>
                      {{ data.item.label }}
                    </span>
                  </template>
                  <template v-slot:cell(data)="data">
                    <InputText
                      v-if="data.item.isEdit"
                      textFloat=""
                      placeholder=""
                      type="text"
                      name="dataLabel"
                      isRequired
                      v-model="data.item.data"
                      :isValidate="
                        $v.form.imageMap.$each.$iter[index].action.$each.$iter[
                          data.index
                        ].data.$error
                      "
                    />
                    <span v-else>
                      {{ data.item.data }}
                    </span>
                  </template>
                  <template v-slot:cell(sortOrder)="data">
                    <InputText
                      v-if="data.item.isEdit"
                      textFloat=""
                      placeholder=""
                      type="text"
                      name="sortOrder"
                      isRequired
                      v-model="data.item.sortOrder"
                      :isValidate="
                        $v.form.imageMap.$each.$iter[index].action.$each.$iter[
                          data.index
                        ].sortOrder.$error
                      "
                    />
                    <span v-else>
                      {{ data.item.sortOrder }}
                    </span>
                  </template>
                  <template v-slot:cell(id)="data">
                    <u
                      class="pointer"
                      v-if="!data.item.isEdit"
                      @click="onSetEditToRecord(data.item, index)"
                      >แก้ไข</u
                    >

                    <button
                      type="button"
                      class="
                        btn btn-main btn-details-set
                        ml-md-2
                        mr-2
                        text-uppercase
                      "
                      v-if="data.item.isEdit"
                      @click="checkFormByRecord(index, data.index)"
                    >
                      <div class="d-flex">
                        <font-awesome-icon
                          icon="save"
                          class="ml-auto my-auto mr-2"
                        />
                        <div class="my-auto mr-auto">บันทึก</div>
                      </div>
                    </button>
                    <u
                      class="pointer"
                      v-if="data.item.isEdit"
                      @click="onUnsetEditToRecord(data.item, index, data.index)"
                      >ยกเลิก</u
                    >
                  </template>
                </b-table>
              </div>
              <div
                v-if="$v.form.imageMap.$each.$iter[index].action.$error"
                class="text-error"
              >
                กรุณากรอกข้อมูลให้ครบถ้วน
              </div>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-3">
          <b-col class="text-sm-right">
            <button
              type="button"
              @click="checkForm()"
              :disabled="isDisable"
              class="btn btn-main btn-details-set ml-md-2 text-uppercase"
            >
              SAVE
            </button>
          </b-col>
        </b-row>
      </div>
    </div>

    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import UploadFile from "@/components/inputs/UploadFile";
import { required, requiredIf } from "vuelidate/lib/validators";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  name: "ImageMapIndex",
  components: {
    InputText,
    InputTextArea,
    UploadFile,
    ModalLoading,
    ModalAlertConfirm,
  },
  data() {
    return {
      form: {
        imageMap: [
          {
            imageMap: {
              id: 0,
              brandId: 1,
              languageId: 1,
              imageUrl: "",
              name: "",
              description: "",
              createdBy: "",
              createdTime: "",
              updatedBy: "",
              updatedTime: "",
            },
            action: [
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 1,
                isEdit: true,
                languageId: 1,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 2,
                isEdit: true,
                languageId: 1,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 3,
                isEdit: true,
                languageId: 1,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 4,
                isEdit: true,
                languageId: 1,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 5,
                isEdit: true,
                languageId: 1,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 6,
                isEdit: true,
                languageId: 1,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 7,
                isEdit: true,
                languageId: 1,
              },
            ],
          },
          {
            imageMap: {
              id: 2,
              brandId: 1,
              languageId: 2,
              imageUrl: "",
              name: "",
              description: "",
              createdBy: "",
              createdTime: "",
              updatedBy: "",
              updatedTime: "",
            },
            action: [
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 1,
                isEdit: true,
                languageId: 2,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 2,
                isEdit: true,
                languageId: 2,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 3,
                isEdit: true,
                languageId: 2,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 4,
                isEdit: true,
                languageId: 2,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 5,
                isEdit: true,
                languageId: 2,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 6,
                isEdit: true,
                languageId: 2,
              },
              {
                id: 0,
                imageMapId: 0,
                label: "",
                data: "",
                actionTypeId: 3,
                sortOrder: 7,
                isEdit: true,
                languageId: 2,
              },
            ],
          },
        ],
      },
      languageActiveId: 1,
      isLoadingImage: false,
      isDisable: false,
      modalMessage: "",
      items: [{ text: "Dickerson", label: "MacDonald" }],
      tempAction: {},
      fields: [
        {
          key: "label",
          label: "ข้อความ",
          class: "",
        },
        {
          key: "data",
          label: "ป้ายชื่อ",
          class: "",
        },
        {
          key: "sortOrder",
          label: "ลำดับที่",
          class: "",
        },
        {
          key: "id",
          label: "",
          class: "",
        },
      ],
      isBusy: false,
    };
  },
  validations: {
    form: {
      imageMap: {
        $each: {
          imageMap: {
            imageUrl: {
              required: requiredIf(function (item) {
                return item.languageId == this.languageActiveId;
              }),
            },
            description: {
              required: requiredIf(function (item) {
                return item.languageId == this.languageActiveId;
              }),
            },
          },
          action: {
            $each: {
              label: {
                required: requiredIf(function (item) {
                  return item.languageId == this.languageActiveId;
                }),
              },
              data: {
                required: requiredIf(function (item) {
                  return item.languageId == this.languageActiveId;
                }),
              },
              sortOrder: {
                required: requiredIf(function (item) {
                  return item.languageId == this.languageActiveId;
                }),
              },
            },
          },
        },
      },
    },
  },
  created: async function () {
    await this.getImageMap();
  },
  methods: {
    onUnsetEditToRecord(val, index, actionIndex) {
      val.data = this.tempAction[index].action[actionIndex].data;
      val.label = this.tempAction[index].action[actionIndex].label;
      val.sortOrder = this.tempAction[index].action[actionIndex].sortOrder;
      val.isEdit = false;
    },
    onSetEditToRecord(val) {
      val.isEdit = true;
    },
    onChangeLanguageActive(val) {
      let index = this.form.imageMap.findIndex(
        (el) => el.imageMap.languageId == this.languageActiveId
      );
      if (index > -1) {
        this.$v.form.imageMap.$each.$iter[index].action.$touch();
        if (this.$v.form.imageMap.$each.$iter[index].action.$error) {
          return;
        }
        this.languageActiveId = val;
        this.$v.form.$reset();
      }
    },
    checkFormByRecord: async function (index, activeIndex) {
      // this.$v.form.imageMap[index].action..$touch();
      this.$v.form.imageMap.$each.$iter[index].action.$each.$iter[
        activeIndex
      ].$touch();
      if (
        this.$v.form.imageMap.$each.$iter[index].action.$each.$iter[activeIndex]
          .$error
      ) {
        return;
      }
      this.submit();
    },
    checkForm: async function () {
      this.$v.form.imageMap.$touch();
      if (this.$v.form.imageMap.$error) {
        return;
      }
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/imageMap`, this.form)
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : "สำเร็จ" });
            this.getImageMap();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
          }
          this.isDisable = false;
        });
    },
    removeUnused: async function () {
      this.form.imageMap.forEach((element) => {
        element.action = element.action.map((el) => {
          delete el.isEdit;
          delete el.languageId;
        });
      });
    },
    onImageChange(img, index) {
      this.isLoadingImage = true;
      this.isDisable = true;

      var reader = new FileReader();
      reader.readAsDataURL(img);

      reader.onload = async () => {
        this.images = await this.saveImagetoDb(reader.result);
        this.isLoadingImage = false;
        this.isDisable = false;
        this.form.imageMap[index].imageMap.imageUrl = this.images;
      };
    },
    saveImagetoDb: async function (img) {
      var imgData = {
        base64: img,
      };
      return new Promise((resolve, reject) => {
        this.axios
          .post(`${this.$baseUrl}/image/SaveResize`, imgData)
          .then((data) => {
            if (data.result == 1) {
              resolve(data.detail.url);
            } else {
              reject(data);
            }
          });
      });
    },
    onDeleteImage(index) {
      this.form.imageMap[index].imageMap.imageUrl = "";
    },
    getImageMap: async function () {
      this.isBusy = true;
      await this.axios.get(`${this.$baseUrl}/imageMap`).then((data) => {
        if (data.result == 1) {
          if (data.detail.imageMap.length > 0) {
            data.detail.imageMap.forEach((element) => {
              element.action = element.action.map((el) => {
                return {
                  ...el,
                  isEdit: false,
                  languageId: element.imageMap.languageId,
                };
              });
            });
            this.form.imageMap = data.detail.imageMap;
            this.tempAction = JSON.parse(JSON.stringify(data.detail.imageMap));
          }
        }
        this.isBusy = false;
      });
    },
    openModalDelete(value) {
      this.requestDeleteUser.userId = value.userGUID;
      this.modalMessage = "คุณต้องการลบ " + value.username + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/user/${this.requestDeleteUser.userId}`)
        .then((data) => {
          if (data.result == 1) {
            this.filter.PageNo = 1;
            this.getList();
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .div-input {
  margin: 0;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.panel-bg-file-img {
  width: 100%;
  padding-bottom: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  border: 2px dashed #bfbfbf;
  margin-bottom: 15px;
  position: relative;
}
@media (max-width: 767px) {
}
</style>
